<mat-form-field #formFieldContainer floatLabel="always" class="avl-speed-gmap-wrapper">
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div style="width: 100%; height: 500px;  overflow: hidden;">
        <div #targetMap [id]="fieldName+'map'" class="map" style="height: 100%;">

        </div>
    </div>

    <!-- TO DO ?: <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display> -->
</mat-form-field>
